import React, { useEffect, useState } from 'react'
import '../assets/css/procedure.css'
import NutritionValue from './NutritionValue';

export default function Procedure(props) {

  const initialDirections = props.recipeDirections;

  const [directions, setDirections] = useState([]);
  const [servingTotal, setServingTotal] = useState([]);
  const [servingNU, setServingNu] = useState(1);

  useEffect(() => {
    if (initialDirections && initialDirections.length > 0) {
      setDirections(initialDirections);
    }
  }, [initialDirections]);


  const handleCheckboxClickFade = (index) => {
    const updatedDirections = [...directions];
    updatedDirections[index].checked = !updatedDirections[index].checked;
    setDirections(updatedDirections);
  };


  const initialIngredients = props.recipeIngredients;

  const [ingredients, setIngredients] = useState([]);

  useEffect(() => {
    if (initialIngredients && initialIngredients.length > 0) {
      setIngredients(initialIngredients);
      setServingTotal(initialIngredients);
      console.log(ingredients)
    }
  }, [initialIngredients]);

  const handleCheckboxClick = (index) => {
    const updatedIngredients = [...ingredients];
    updatedIngredients[index].checked = !updatedIngredients[index].checked;
    setIngredients(updatedIngredients);
  };

  const servingUpdate = (e) => {
    const totalServing = (servingTotal[0] && servingTotal[0].serving);
    const value = e.target.value;
    const newIngredients = servingTotal.map(items => {
      const valueOfOne = (items.quantity/totalServing);
      const updateValue = Number((value*valueOfOne).toFixed(2));
      return {...items, quantity: updateValue};
    })
    setIngredients(newIngredients);
    setServingNu(value);
  }

  return (
    <div className='wholeRecipeBody'>
    <div className='ingredients'>
      <div className='ingredientsHeading'>Ingredients:</div>
    </div>
    <table className="table ingredientsTypo">
      <thead>
        <tr>
          <th scope="col" colSpan={2}>Adjust Servings <form style={{display: 'inline-block', paddingLeft:'1rem'}}><input type="number" inputMode="numeric" defaultValue={(initialIngredients[0] && initialIngredients[0].serving)} onChange={servingUpdate}></input></form></th>
        </tr>
      </thead>
      <tbody>
        {ingredients.map((ingredient, index) => (
          <tr key={index}>
            <td scope="row" className={`checkBoxInit ${ingredient.checked ? 'textTransform' : ''}`}>
              <input type='checkbox' onClick={() => handleCheckboxClick(index)} />
              <i className="fa-solid fa-check checkboxCheck"></i>
            </td>
            <td className={`w-100 ${ingredient.checked ? 'textTransform' : ''}`}>{ingredient.name} {ingredient.quantity} {ingredient.units}</td>
          </tr>
        ))}
      </tbody>
    </table>

          <NutritionValue nutrition={props.recipeNutrition} serving={servingNU}/>

    <div className='row'>
      <div className='ingredientsHeading col-3'>Directions</div>
      <div className='col-9 pt-4' style={{marginTop: '12px'}}><hr/></div>
    </div>

<div className='RecipeBody'>
      {directions.map((direction, index) => (
        <div className={`directions row ${direction.checked ? 'fadeAway' : 'fadeOn'}`} key={index}>
          <div className='directionHeadingCount col-1'>
            <span>{direction.stepNumber}.</span>
          </div>
          <div className='procedure col-11'>
            <div className='directionHeading'>{direction.heading}</div>
              <div className='ProcedureImages'>
                {direction.image.map((img, indexs) => (
                  <img src={img} alt='image' key={indexs}></img>
                ))}
              </div>
            <p>{direction.description}</p>
            <div className='markComplete'>
              <input type='checkbox' checked={direction.checked} onChange={() => handleCheckboxClickFade(index)} />{' '} Mark Complete
              <i className="fa-solid fa-check checkboxCheck"></i>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
  )
}
